import { getColWidth } from '@modules/dashboard/components/Layout/helpers';
import { GUTTER_SIZE } from '@modules/dashboard/constants';
import { DashboardCell } from 'generated/graphql';

interface getCellWidthParams {
  colSpan: number;
  rowWidth: number;
  rowCells: DashboardCell[];
}

export function getCellWidth({
  colSpan,
  rowCells,
  rowWidth,
}: getCellWidthParams) {
  if (rowCells.length === 1 && !rowWidth) {
    return `100%`;
  }

  return `${getColWidth(rowWidth) * colSpan + GUTTER_SIZE * (colSpan - 1)}px`;
}
